export default "__VITE_ASSET__DM0Qa6HU__"